import { Model } from '@/models/Model';
export class UserRelationship extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'UserRelationship';
        this.$endpoint = '/users/{user}/relationships/relationships/{id}';
        this.$fillable = [];
    }
    user(user) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/relationships/${this.id}`;
        return this;
    }
    setIdAttribute(id) {
        this.$endpoint = `/users/${this.user}/relationships/relationships/${id}`;
        return this;
    }
    resolvePrimaryKey() {
        return '';
    }
}
